import { COUNTRIES } from '../../Constants'

export const BASE_WIDGET_NAME = 'Ninja Chat'

export const CUSTOM_WIDGET_NAMES = {
    dash: {
      [COUNTRIES.SG]: `${BASE_WIDGET_NAME} BETA`
    },
    website: {
      [COUNTRIES.SG]: 'Ship with Ninja Van',
      [COUNTRIES.MY]: 'Ship with Ninja Van',
      [COUNTRIES.ID]: 'Ship with Ninja Xpress',
      [COUNTRIES.PH]: 'Ship with Ninja Van',
      [COUNTRIES.TH]: 'Ship with Ninja Van',
      [COUNTRIES.VN]: 'Ship with Ninja Van'
    }
}
